import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './features.css'

const LargeBlock = ({ title, text, image, fullHeight, centerText }) => (
  <div styleName={fullHeight ? 'block-full' : 'block-normal'}>
    <div styleName={centerText ? 'block__content-center' : 'block__content-space'}>
      <div styleName="title">{title}</div>
      <div styleName="text">{text}</div>
    </div>

    <div
      style={{ backgroundImage: `url(${image})` }}
      styleName="block__img"
    />
  </div>
)

LargeBlock.propTypes = {
  centerText: PropTypes.bool,
  fullHeight: PropTypes.bool,
  image: PropTypes.string,
  text: PropTypes.any,
  title: PropTypes.string,
}

export default CSSModules(LargeBlock, styles)



/** WEBPACK FOOTER **
 ** ./src/containers/ticketing-page/features/large-block.js
 **/